<template>
  <div class="electron-code-sheet-con">
    <template v-if="isNewOrder === 'YES'">
      <!-- <button class="scale-button" @click="visible = true"></button> -->
      <div class="scale-model-block">
        <!-- <p class="margin-bottom-20">修改码单尺寸</p> -->
        <RadioGroup
          v-model="scaleType"
          :list="scaleTypeList"
        />
      </div>
    </template>
    <!-- <div class="tips">
      注意：本凭证所载货物如有质量问题，请于本凭证确认签收之日起5日内将货物退回我司检验处理。
      逾期提出退换货要求、已裁剪或加工（缩水、洗 水、印花等后工艺加工）的货物，本司恕不负责协调处理退换货事宜。
    </div>
    <div class="info">
      <div class="info-list">
        <div class="info-list_til">订单编号</div>
        <div class="info-list_con">{{ electronicCodeData.orderId || '---'}}</div>
      </div>
      <div class="info-list">
        <div class="info-list_til">下单时间</div>
        <div class="info-list_con">
          {{ electronicCodeData.orderTime || '---'}}
        </div>
      </div>
      <div class="info-list">
        <div class="info-list_til">客户公司</div>
        <div class="info-list_con">
          {{ electronicCodeData.factoryName || '---'}}
        </div>
      </div>
      <div class="info-list">
        <div class="info-list_til">客户名称</div>
        <div class="info-list_con">
          {{ electronicCodeData.buyerName || '---'}}
          {{ electronicCodeData.buyerMobile ? electronicCodeData.buyerMobile : ''}}
        </div>
      </div>
      <div class="info-list">
        <div class="info-list_til">货款类型</div>
        <div class="info-list_con">
          {{ electronicCodeData.paymentPrec || '---'}}
        </div>
      </div>
      <div class="info-list">
        <div class="info-list_til">配送方式</div>
        <div class="info-list_con">
          {{ electronicCodeData.logistics || '---'}}
        </div>
      </div>
    </div>
    <div
      class="detailed"
      v-for="(item, index) in productsData"
      :key="item.id"
    >
      <div
        class="detailed-til"
        v-if="index === 0"
      >
        出货明细
      </div>
      <div class="detailed-info">
        <div class="detailed-info_l">
          <div>{{ item.productName}}</div>
          <div class="color">{{ item.productColorNo}}</div>
        </div>
        <div class="detailed-info_r">￥{{ item.productMoney || '0'}}</div>
      </div>
      <div class="detailed-con">
        <div class="detailed-con_top">
          <div class="con">
            <div class="con-top">条数</div>
            <div class="con-bot">{{item.deliveryCount}}</div>
          </div>
          <div class="con">
            <div class="con-top">数量</div>
            <div class="con-bot">{{ item.productAmount}}</div>
          </div>
          <div class="con">
            <div class="con-top">优惠</div>
            <div class="con-bot">{{ item.discountAmount}}</div>
          </div>
        </div>
        <div class="detailed-con_bot">
          <div class="con">
            <div class="con-top">单位</div>
            <div class="con-bot">{{ item.unit}}</div>
          </div>
          <div class="con">
            <div class="con-top">单价</div>
            <div class="con-bot">￥{{ item.salePrice || '0'}}</div>
          </div>
          <div class="con"></div>
        </div>
      </div>
      <div class="detailed-bot">
        <div
          class="detailed-bot_list"
          v-for="(x, index02) in item.deliveryList"
          :key="index02"
        >
          {{x}}
        </div>
      </div>
    </div>
    <div
      class="money-con info"
      :class="{'download-hide': downloadHide}"
    >
      <div class="info-list">
        <div class="info-list_til">实付金额</div>
        <div class="info-list_con money-color">￥{{electronicCodeData.orderMoney || '0'}}</div>
      </div>
      <div class="info-list">
        <div class="info-list_til">已付金额</div>
        <div class="info-list_con">￥{{electronicCodeData.payment || '0'}}</div>
      </div>
      <div class="info-list">
        <div class="info-list_til">待付金额</div>
        <div class="info-list_con">￥{{ electronicCodeData.waitPay || '0'}}</div>
      </div>
    </div> -->
    <!-- <div
      class="footer"
      v-if="!downloadHide"
    >
      <div
        class="footer-dow"
        @click="predivCodeSheet"
      >
        查看细码单
      </div>
      <div
        v-if="confirmCodeSheetShow"
        class="footer-dow"
        @click="confirmCodeSheet"
      >
        确认码单
      </div>
    </div> scaleType === '1' &&  -->
    <transition name="slide-fade">
      <div
        class="code-sheet"
        :style="(isNewOrder === 'YES') ? 'overflow: hidden': ''"
      >
        <div id="code-sheet-con">
          <CodeSheet
            ref="CodeSheet"
            v-if="!(isNewOrder === 'YES')"
            :orderId="orderId"
            :workerId="workerId"
            @success="handleCodeSheetSuccess"
          ></CodeSheet>
          <CodeSheetNew
            ref="CodeSheet"
            v-else-if="electronicCodeData"
            :electronicCodeData="electronicCodeData"
            :isNewOrder="isNewOrder"
            :isBillPaid="isBillPaid"
            :orderId="orderId"
            :orderCode="orderCode"
            :scaleType="scaleType"
            @success="handleCodeSheetSuccess"
          ></CodeSheetNew>
        </div>
        <div
          class="footer"
        >
          <div
            v-if="confirmCodeSheetShow && $route.query.source_app !== 'Flutter'"
            class="footer-dow"
            @click="confirmCodeSheet"
          >
            确认码单
          </div>
          <!--v-if="browser.mobile || browser.android || browser.ios"  -->
          <div
            class="footer-dow"
            @click="downloadCodeSheet"
          >保存为图片</div>
        </div>
        <!-- <div class="cancel-download">
          <div
            class="cancel-download_c"
            @click="closePredivCodeSheet"
          >
            {{ isPrediv ? '关闭' : '返回' }}
          </div>
          <div
            class="cancel-download_d"
            @click="downloadCodeSheet"
            v-if="!isPrediv"
          >确定下载</div>
        </div> -->
      </div>
    </transition>

    <div
      class="integral-dialog"
      :class="{active: booleanTips === 'YES'}"
    >
      <div class="integral-dialog-container">
        <img class="integral-icon" :src="require('@/assets/baibu/integral-dialog-bg.png')" />
        <div class="integral-title">查询码单信息</div>
        <div class="integral-tip">恭喜获得积分</div>
        <div class="integral-score">+{{ points }}</div>
        <div class="integral-footer">
          <button
            class="integral-btn integral-btn--cancel"
            @click="booleanTips = 'NO'"
          >好的
          </button>
          <button
            class="integral-btn integral-btn--submit"
            @click="toInttgralPage"
          >查看更多明细
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import {
  getElectronCodeSheet,
  getNewElectronCodeSheet,
  confirmElectronCodeSheet,
  confirmNewElectronCodeSheet,
  appletOrderPage,
} from '@/api/baibu';
import { sendBehaviorReport } from '@/api/base';
import RadioGroup from '@/components/radio-group';
import CodeSheet from './components/code-sheet';
import CodeSheetNew from './components/code-sheet-new';
import wx from 'weixin-js-sdk';
import { browser } from '@/utils/browser';
import { downloadBase64 } from '@/utils/download-base64';

export default {
  name: 'BaibuElectronCodeSheet',
  data() {
    return {
      browser,
      scaleType: '1',
      scaleTypeList: [{
        value: '1',
        name: '适配屏幕宽度',
      }, {
        value: '2',
        name: '原始尺寸 100%',
      }],
      visible: false,
      points: 0,
      booleanTips: 'NO',
      orderCode: '', // 订单编号
      isOnPageJumping: false, // 正在跳转
      isRenderingCodeSheet: true, // 正在渲染表单数据，不允许下载图片
      workerId: '', // 登录ID；
      currentUserId: '', // 登录ID;
      currentUserName: '', // 登录人;
      orderId: '', // 订单id;
      productsData: [], // 产品信息;
      // electronicCodeData: {}, // 码单信息;
      codeSheetOff: false, // 预览电子码单开关；
      downloadHide: false, // 是否显示下载电子码单；
      isPrediv: false, // 是否显示下载电子码单；
      // productsData: [], // 产品信息;
      electronicCodeData: null, // 码单信息;
      // codeSheetOff: false, // 预览电子码单开关；
      // downloadHide: false, // 是否显示下载电子码单；
      // isPreview: false, // 是否显示下载电子码单；
      confirmCodeSheetShow: false, // 是否显示确认码单
      isNewOrder: 'NO', // 是否新订单
      isBillPaid: 'NO',
      authCode: [], // 用户权限
      query: {},
      unconfirmedCodeNumber: 0,
    };
  },

  created() {
    this.orderId = this.$route.query.orderId || '';
    this.isNewOrder = this.$route.query.isNewOrder || 'NO';
    this.workerId = this.$route.query.workerId || '';
    this.currentUserId = this.$route.query.currentUserId || '';
    this.currentUserName = decodeURIComponent(this.$route.query.currentUserName || '');
    this.authCode = decodeURIComponent(this.$route.query.authCode).split(',');
    this.booleanTips = this.$route.query.booleanTips || 'NO';
    this.points = this.$route.query.points || 0;
    this.query = this.$route.query;

    if (this.$route.query.downloadHide) {
      this.downloadHide = true;
    }
    if (this.$route.query.isPrediv) {
      this.isPrediv = true;
    }
    // document.title = '查看电子码单';
    // if (this.$route.query.downloadHide) {
    //   this.downloadHide = true;
    // }
    // if (this.$route.query.isPreview) {
    //   this.isPreview = true;
    // }
    document.title = '电子码单';
    this.getDetails();
  },

  mounted() {},

  computed: {
    checkAuthCode() {
      const { authCode } = this;
      // authCode=null 返回false
      return !authCode.includes('null') || authCode.includes('CONFIRM_CODE_LIST');
    },
  },

  components: {
    RadioGroup,
    CodeSheet,
    CodeSheetNew,
  },

  methods: {
    // 埋点确认按钮
    handleTrack() {
      const trackCommonData = JSON.parse(decodeURIComponent(this.query.EventTrackCommonData));
      const params = {
        ...JSON.parse(this.query.trackData),
        events: [{
          attr: {
            btnName: '确认码单',
            oneId: null,
            openId: trackCommonData.openId,
            pageName: '码单预览',
            pagePath: 'baibu/electron-code-sheet',
            phone: trackCommonData.mobile,
            purchaserId: trackCommonData.purchaserAccountInfo.purchaserId,
            scene: 1001,
            storageInfo: {},
            token: trackCommonData.token,
            unionId: trackCommonData.unionId,
          },
          eventId: 'E100000011',
          eventTime: new Date().getTime(),
        }],
      };
      sendBehaviorReport(params);
    },
    // 确认码单
    confirmCodeSheet() {
      this.$dialog
        .confirm({
          title: '提示',
          message: '确认码单后，将无法修改码单，是否继续？',
        })
        .then(() => {
          if (this.isNewOrder === 'YES') {
            const {
              paymentFinancialLoanDays,
              paymentMethod,
            } = this.electronicCodeData.paymentInfo;
            confirmNewElectronCodeSheet({
              orderId: this.orderId,
              currentUserId: this.currentUserId,
              currentUserName: this.currentUserName,
              paymentFinancialLoanDays,
              paymentMethod,
            }).then(({ successful, message }) => {
              if (successful) {
                this.$toast.success('确认码单成功');
                this.confirmCodeSheetShow = false;
                if (window.__wxjs_environment === 'miniprogram') {
                  this.selectPaymentOrConfirmCode();
                }
              } else {
                this.$toast.fail(`确认码单失败 ${message}`);
              }
            });
          } else {
            confirmElectronCodeSheet({
              orderId: this.orderId,
              currentUserId: this.currentUserId,
              currentUserName: this.currentUserName,
            }).then(({ successful, message }) => {
              if (successful) {
                this.$toast.success('确认码单成功');
                this.confirmCodeSheetShow = false;
                if (window.__wxjs_environment === 'miniprogram') {
                  this.selectPaymentOrConfirmCode();
                }
              } else {
                this.$toast.fail(`确认码单失败 ${message}`);
              }
            });
          }
          // 小程序里则调用 暂时停止上报
          // if (this.query.source_app !== 'Flutter') {
          //   this.handleTrack();
          // }
        });
    },
    // 获取电子码单详情；
    getDetails() {
      if (this.isNewOrder === 'NO') {
        getElectronCodeSheet(this.orderId).then((res) => {
          if (res.data) {
            // this.electronicCodeData = res.data.electronicCode || {};
            // this.productsData = res.data.products || [];
            this.confirmCodeSheetShow = (this.checkAuthCode && res.data.confirmMemoButton) || false;
          }
        }, () => {
          this.isRenderingCodeSheet = false;
        });
        return;
      }
      getNewElectronCodeSheet({
        orderId: this.orderId,
        orderCodeTypeEnum: 'BAI_BU',
        currentUserId: this.currentUserId,
      }).then((res) => {
        if (res.data) {
          this.electronicCodeData = res.data || {};
          this.orderCode = res.data?.order.orderCode || '';
          this.isBillPaid = res?.data?.isBillPaid || 'NO';
          // this.productsData = res.data.products || [];
          this.confirmCodeSheetShow = res.data.buttonList.some(item => item.value === 'CONFIRM_CODE_LIST') && this.checkAuthCode;
        }
      }, () => {
        this.isRenderingCodeSheet = false;
      });
    },
    // getDetails() {
    //   getElectronCodeSheet(this.orderId).then((res) => {
    //     if (res.data) {
    //       this.electronicCodeData = res.data.electronicCode || {};
    //       this.productsData = res.data.products || [];
    //       this.confirmCodeSheetShow = res.data.confirmMemoButton || false;
    //     }
    //   }, () => {
    //     this.isRenderingCodeSheet = false;
    //   });
    // },

    // 预览电子码单方法；
    // previewCodeSheet() {
    //   this.codeSheetOff = true;
    //   window.scroll(0, 0);
    //   document.body.style.position = 'fixed';
    // },
    // 表单渲染完成
    handleCodeSheetSuccess() {
      this.isRenderingCodeSheet = false;
    },

    // closePreviewCodeSheet() {
    //   this.codeSheetOff = false;
    //   document.body.style.position = 'static';
    // },

    toInttgralPage() {
      if (window.__wxjs_environment === 'miniprogram') {
        wx.miniProgram.navigateTo({
          url: '/pages/subPage-integral/index',
        });
      }
    },

    // 获取待确认码单列表
    async queryUnconfirmedCodeList() {
      const {
        buyerId,
        buyerNo,
        purchaserId,
      } = JSON.parse(decodeURIComponent(this.query.EventTrackCommonData));
      this.unconfirmedCodeNumber = (await appletOrderPage({
        buyerId,
        buyerNo,
        currentUserId: this.$route.query.currentUserId,
        purchaserId,
        orderPoDetailStatusEnums: ['WAIT_CHECK'],
        searchStatus: 'WAIT_ACCEPT',
        pageNum: 1,
        pageSize: 99,
      }))?.data?.list?.length || 0;
    },

    // 返回支付
    returnPayment() {
      const trackCommonData = JSON.parse(decodeURIComponent(this.query.EventTrackCommonData));
      const {
        orderId = '',
        detailQueryOS = '',
        detailQueryOrderCode = '',
        detailQueryStatus = '',
        isNewOrder = '',
      } = this.$route.query;
      if (window.__wxjs_environment === 'miniprogram') {
        if (trackCommonData.pagePath !== 'pages/order/list/index') {
          wx.miniProgram.navigateTo({
            url: `/${trackCommonData.pagePath}?os=${detailQueryOS}&orderId=${orderId}&orderCode=${detailQueryOrderCode}&status=${detailQueryStatus}&isNewOrder=${isNewOrder}&tabType=WAIT_PAYMENT`,
          });
        } else {
          wx.miniProgram.navigateTo({
            url: `/subPage-order/detail/index?os=${detailQueryOS}&orderId=${orderId}&orderCode=${detailQueryOrderCode}&status=${detailQueryStatus}&isNewOrder=${isNewOrder}&tabType=WAIT_PAYMENT`,
          });
        }
      }
    },

    // 继续确认码单
    continueConfirmCode() {
      if (window.__wxjs_environment === 'miniprogram') {
        wx.miniProgram.postMessage({
          data: {
            type: '待确认',
          },
        });
        wx.miniProgram.reLaunch({
          url: '/pages/order/list/index',
        });
      }
    },

    // 选择关闭 or 继续确认码单
    async selectPaymentOrConfirmCode() {
      await this.queryUnconfirmedCodeList();
      if (this.unconfirmedCodeNumber) {
        this.$dialog.confirm({
          title: '码单确认成功',
          message: `还有 ${this.unconfirmedCodeNumber} 条待确认码单，是否继续确认？`,
          cancelButtonText: '取消',
          confirmButtonText: '继续确认码单',
        }).then(() => {
          this.continueConfirmCode();
        });
      }
    },

    // 下载电子码单方法；
    async downloadCodeSheet() {
      if (this.isRenderingCodeSheet) {
        this.$toast.fail('正在渲染码单，请稍后再进行下载！');
        return;
      }
      if (this.isOnPageJumping) {
        return;
      }
      this.isOnPageJumping = true;
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '图片生成中，请稍候...',
      });
      if (this.isNewOrder === 'YES') {
        this.$refs.CodeSheet.deltaY = 0;
        this.$refs.CodeSheet.deltaX = 0;
        await this.$nextTick();
      }
      // doubleTapHandler
      const codeCon = document.querySelector('#code-sheet-self');
      const {
        curScale = 1,
      } = this.$refs?.CodeSheet;
      html2canvas(codeCon, {
        ...(
          curScale === 1 ? {} : {
            width: codeCon.scrollWidth * curScale,
            height: codeCon.scrollHeight * curScale,
          }
        ),
      }).then((canvas) => {
        const image = canvas.toDataURL('image/png', 1);
        // 适配pc
        if (!browser.mobile && !browser.android && !browser.ios) {
          downloadBase64(image, this.electronicCodeData.order.orderCode);

          this.isOnPageJumping = false;
          this.$toast.clear();
          return;
        }
        if (window.__wxjs_environment === 'miniprogram') {
          // 微信小程序的环境下
          // wx.miniProgram.postMessage({
          //   data: {
          //     imgData: image, // 刚才拿到的base64 数据
          //   },
          // });

          wx.miniProgram.navigateTo({
            url: `/subPage-common/download-img/index?image=${encodeURIComponent(image)}`,
          });
          setTimeout(() => {
            this.isOnPageJumping = false;
            this.$toast.clear();
          }, 500);
          // wx.miniProgram.navigateBack({ delta: 1 });
        } else {
          this.$toast.clear();
          this.isOnPageJumping = false;
          window.JSBridge.invoke({
            bridgeName: 'saveImage',
            data: image,
            callback: (res) => {
              console.log(res);
            },
          });
        }
      }, () => {
        this.$toast.clear();
        this.$toast.fail('图片生成失败！请退出重试');
        this.isOnPageJumping = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .scale-model-block {
    position: fixed;
    display: flex;
    // align-items: center;
    // justify-content: center;
    // padding-top: 20%;
    // top: 0;
    // bottom: 0;
    // left: 0;
    // right: 0;
    // background: rgba(0, 0, 0, .5);
    top: 10PX;
    left: 10PX;
    flex-direction: column;
    color: #fff;
    box-sizing: border-box;
    z-index: 11;
    opacity: .5;
  }

  .scale-button {
    position: fixed;
    top: 10PX;
    right: 10PX;
    background: url(../../assets/baibu/icon-setting.png) 0 0 no-repeat;
    width: 36PX;
    height: 36PX;
    z-index: 9;
    border: 0;
    outline: none;
  }

  .electron-code-sheet-con{
    // position: absolute;
    // top: 0;
    // left: 0;
    // width: 100%;
    // height: 100%;
    // padding: 10px 15px 0 15px;
    overflow-y: auto;
    background: rgba(248,248,248,1);
    color: rgba(51,51,51,1);
  }
  .block-bg{
    margin-top: 15px;
    background: rgba(255,255,255,1);
    border-radius: 8px;
  }
  // .money-color{
  //   color: rgba(207,71,57,1);
  // }
  // .tips{
  //   padding: 15px;
  //   background: rgba(181,186,192,1);
  //   border-radius: 8px;
  //   font-size: 12px;
  //   font-weight: 400;
  //   color: rgba(255,255,255,1);
  //   line-height: 17px;
  // }
  // .info{
  //   padding: 25px 20px;
  //   font-size: 14px;
  //   @extend .block-bg;
  //   &-list{
  //     display: flex;
  //     margin-bottom: 16px;
  //     line-height: 20px;
  //     &_til{
  //       color: rgba(153,153,153,1);
  //     }
  //     &_con{
  //       flex: 1;
  //       padding-left: 10px;
  //       text-align: right;
  //     }
  //   }
  // }
  // .detailed{
  //   padding: 15px 20px 22px 20px;
  //   @extend .block-bg;
  //   &-til{
  //     padding-bottom: 22px;
  //     font-size: 16px;
  //     font-weight: 400;
  //     line-height: 22px;
  //   }
  //   &-info{
  //     display: flex;
  //     padding-bottom: 15px;
  //     &_l{
  //       font-size: 14px;
  //       line-height: 20px;
  //       .color{
  //         color: rgba(153,153,153,1);
  //       }
  //     }
  //     &_r{
  //       flex: 1;
  //       padding-left: 10px;
  //       font-size: 20px;
  //       font-weight: 400;
  //       color: rgba(207,71,57,1);
  //       line-height: 28px;
  //       text-align: right;
  //     }
  //   }
  //   &-con{
  //     padding: 0 20px;
  //     background: rgba(248,248,248,1);
  //     border-radius: 8px;
  //     border: 1px solid rgba(221,221,221,1);
  //     &_top{
  //       display: flex;
  //       border-bottom: 1px solid #DDDDDD;
  //     }
  //     &_bot{
  //       display: flex;
  //     }
  //     .con{
  //       padding: 15px 0;
  //       flex: 1;
  //       text-align: center;
  //       &-top{
  //         font-size: 12px;
  //         color: rgba(153,153,153,1);
  //         line-height: 17px;
  //       }
  //       &-bot{
  //         font-size: 14px;
  //         line-height: 20px;
  //       }
  //     }
  //   }
  //   &-bot{
  //     display: flex;
  //     flex-wrap: wrap;
  //     padding-top: 15px;
  //     &_list{
  //       height: 20px;
  //       margin: 10px 10px 0 0;
  //       padding: 0 12px;
  //       border-radius: 13px;
  //       border: 1px solid rgba(221,221,221,1);
  //       line-height: 20px;
  //     }
  //   }
  // }
  // .money-con{
  //   &.download-hide{
  //     margin-bottom: 20px;
  //   }
  //   margin-bottom: 75px;
  // }
  .footer{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    // max-width: 799PX;
    height: 60px;
    background: rgba(255,255,255,1);
    box-shadow: 0 1px 0 0 rgba(221,221,221,1);
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 10px;
    &-dow{
      flex: 1;
      height: 65%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      margin: 0 5px;
      color: rgba(255,255,255,1);
      border-radius: 30px;
      &:nth-child(1) {
        background: rgb(250, 107, 67);
      }
      &:nth-child(2) {
        background: rgb(254, 142, 70);
      }
      &:nth-child(3) {
        background: rgb(254, 182, 73);
      }
    }
  }
  .code-sheet{
    position: fixed;
    width: 100%;
    height: 100%;
    padding-bottom: 60px;
    top: 0;
    left: 0;
    background-color: #FFFFFF;
    overflow: auto;
    #code-sheet-con{
      display: inline-block;
      // width: 100%;
    }
    // .cancel-download{
    //   display: flex;
    //   width: 345px;
    //   height: 44px;
    //   position: fixed;
    //   top: 0;
    //   right: 0;
    //   bottom: 0;
    //   left: 0;
    //   margin: auto auto 10px auto;
    //   font-size: 14px;
    //   line-height: 44px;
    //   text-align: center;
    //   border-radius: 30px;
    //   overflow: hidden;
    //   &_c{
    //     flex: 1;
    //     background-color: #dddddd;
    //   }
    //   &_d{
    //     flex: 1;
    //     color: #FFFFFF;
    //     background-color: #f77b47;
    //   }
    // }
  }
  .slide-fade-enter-active {
    transition: all .4s ease;
  }
  .slide-fade-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
  }


</style>
<style lang="scss">
@keyframes showDialog {
  from {
    transform: scale3d(0, 0, 1);
  }
  to {
    transform: scale3d(1, 1, 1);
  }
}

.integral-dialog {
  position: fixed;
  display: none;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  &.active {
    display: flex;
    .integral-dialog-container {
      animation: showDialog .4s .4s 1 forwards;
    }
  }
}
.integral-dialog-container {
  // margin: 40% auto 0;
  transform: scale3d(0, 0, 1);
  position: relative;
  padding-top: 174px;
  height: 413px;
  width: 325px;
  background: linear-gradient(360deg, #DEFFFA 0%, #FFFFFF 100%);
  border-radius: 8px;
  box-sizing: border-box;
}
.integral-icon {
  position: absolute;
  top: -60px;
  width: 325px;
  height: 234px;
}
.integral-title {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #333333;
  line-height: 28px;
  margin: 13px 0 4px;
}
.integral-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 400;
  color: #666666;
  line-height: 17px;
  &::after, &::before {
    content: '';
    display: inline-block;
    width: 25px;
    height: 1px;
    background: #999;
  }
  &::after {
    margin-left: 7px;
  }
  &::before {
    margin-right: 7px;
  }
}

.integral-score {
  margin: 10px 0 20px;
  font-size: 50px;
  color: #FFC800;
  text-align: center;
  font-weight: bold;
  line-height: 69px;
}
.integral-footer {
  display: flex;
  align-items: center;
  justify-content: center;
}
.integral-btn {
  width: 135px;
  height: 50px;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  line-height: 50px;
  border: 0;
  margin: 0;
  opacity: 1;
  transition: all .3s;
  &::after {
    display: none;
  }
  &--cancel {
    background: #FFFFFF;
    &:active {
      background: rgba(255, 255, 255, .5);
    }
  }
  &--submit {
    margin-left: 20px;
    background: linear-gradient(270deg, #FFEB54 0%, #FFC206 100%);
    &:active {
      opacity: .5;
    }
  }
}
.overlay-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 300px;
  height: 150px;
  border-radius: 20px;
  background-color: #FFFFFF;
}
</style>
